<template>
	<div>
		<van-popup v-model="create_order_pop" catchtouchmove="ture" position="bottom" style="border-radius: 8px" closeable>
			<div class="co">
				<div class="co_title font_weight flex_center">创建订单</div>
				<div class="co_1">{{good_detail.goods_name}}</div>
				<div class="co_2 flex_space_between">
					预约日期
					<div v-if="book_date_info" @click="openTime()" class="flex_center">
						{{book_date_info.date_obj.date_pio}}　{{book_date_info.time}}
						<img src="../resource/more_999999.png" alt="" />
					</div>
					<div v-else @click="openTime()" class="flex_center co_2_org">
						请选择预约日期
						<!-- <img src="../resource/more_999999.png" alt="" /> -->
					</div>
				</div>
				<div class="co_3 flex_space_between">
					预约人
					<div @click="addGuest()" class="flex_center">
						<img src="../resource/add_F77F28.png" alt="" />
						添加
					</div>
				</div>
				<div class="co_4 flex_space_between">
					<div class="co_4_1 flex_center">本人</div>
					<div class="co_4_2 flex_start">{{user_info.name}}　{{user_info.phone}}</div>
				</div>
				<div v-for="(item_gu,index_gu) in guest" class="co_4 flex_space_between">
					<div class="co_4_1 flex_center">嘉宾</div>
					<div class="co_4_2 flex_start">
						<input v-model="guest[index_gu]" type="text" class="co_4_2_input" placeholder="请输入姓名" />
						<div @click="deleteGuest(index_gu)" class="co_4_2_del flex_center">
							<img src="../resource/delete.png" alt="" />
						</div>
					</div>
				</div>
				<div class="co_5">
					<div class="co_5_1 font_weight">价格明细</div>
					<div class="co_5_2 flex_space_between">
						门市价
						<div>¥{{good_detail.market_price}}</div>
					</div>
					<div class="co_5_2 flex_space_between">
						数量
						<div>{{(guest.length + 1)}}</div>
					</div>
					<div class="co_5_2 flex_space_between">
						折扣
						<div>{{good_detail.price_key=='v60_price'?'6折':'6.5折'}}</div>
					</div>
					<div class="co_5_2 flex_space_between">
						服务费+税费
						<div>15%</div>
					</div>
					<div class="co_5_3 font_weight flex_space_between">
						合计
						<div>¥{{total_price}}</div>
					</div>
				</div>
			</div>
			<div class="co_6 flex_space_between">
				<div class="co_6_left flex_center_end">
					<div class="co_6_left_1">实付：</div>
					<div class="co_6_left_2">¥</div>
					<div class="co_6_left_3">{{total_price}}</div>
				</div>
				<div @click="submitOrder()" class="co_6_right flex_center">提交订单</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	export default {
		props:['good_detail','book_date_info','user_info','max_guest_num','guest'],
		data() {
			return {
				create_order_pop:false,
				total_price:0
			}
		},
		mounted() {},
		methods: {
			openOrderPop(){
				this.create_order_pop=true
				this.computePrice()
			},
			closeOrderPop(){this.create_order_pop=false},
			// 切换预约时间
			openTime(){
				this.$emit('openTime')
			},
			// 新增嘉宾
			addGuest() {
				if (this.guest.length == this.max_guest_num) {
					this.$toast('最大可携带' + this.max_guest_num + '位同行人');
					return
				}
				this.$emit('addGuest')
				// this.guest.push('');
			},
			// 删除嘉宾
			deleteGuest(e) {
				console.log('e',e);
				// this.guest.splice(e, 1);
				this.$emit('deleteGuest',e)
			},
			// 计算价格
			computePrice() {
				console.log('good_detail',this.good_detail);
				var single_price = parseFloat(this.good_detail.price, 10) //单价
				var num = this.guest.length + 1 //数量
				var total_price = single_price * num
				this.total_price = total_price
				console.log('computePrice',total_price);
			},
			// 下单
			submitOrder(){
				var $this = this
				var channel = 'ysf_app'
				var link = ''
				var agent = navigator.userAgent.toLowerCase();
				var isInsideWallet = ((new RegExp(/(com.unionpay.chsp)/).test(agent)) || (new RegExp(
					/(com.unionpay.mobilepay)/).test(agent)));
				if (isInsideWallet) {
					channel = 'ysf_app'
				} else if (agent.match(/MicroMessenger/i) == "micromessenger") {
					channel = 'ysf_xcx'
				}
				if (this.guest.length > 0 && this.guest.join().length == 0) {
					this.$toast('请完善同行人信息！');
					return
				}
				if(!this.book_date_info){
					this.$toast('请完善预约日期！');
					return
				}
				if(!this.book_date_info.date){
					this.$toast('请完善预约日期！');
					return
				}
				if(!this.book_date_info.time){
					this.$toast('请完善预约日期！');
					return
				}
				// console.log('good_detail',this.good_detail);
				// console.log(this.book_date_info);
				var params = {
					goodsId: this.good_detail.goods_id,
					bookDay: this.book_date_info.date,
					bookTime: this.book_date_info.time,
					channel: channel,
					guest: this.guest.join(),
				}
				// console.log(params);
				// return
				this.$loading('正在加载中...');
				var $this = this
				var qs = require('qs');
				var url = this.api.userApi.index_createOrder
				this.axios.post(url, qs.stringify(params))
					.then((res) => {
						console.log(res);
						// $this.page_type=2
						$this.$loading.close();
						$this.closeOrderPop()
						window.location.href = res.data.url
					}).catch((error) => {
						$this.$loading.close();
						$this.$toast(error.msg ? error.msg : error.message);
					})
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.co {
		width: 100%;
		padding: 30*@vm_base 30*@vm_base 0 30*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 0*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 0*@vm_base);
	}
	.co_title {
		width: 100%;
		font-size: 34*@vm_base;
		line-height: calc(48 / 30);
		color: #333333;
	}
	.co_1{
		width: 100%;
		font-size: 32*@vm_base;
		color: #333333;
		line-height: calc(64 / 32);
		margin-top: 28*@vm_base;
	}
	.co_2{
		width: 100%;
		font-size: 28*@vm_base;
		color: #333333;
		padding-bottom: 30*@vm_base;
		border-bottom: 1*@vm_base solid #F0F0F0;
		div{
			height: 60*@vm_base;
			img{
				width: 36*@vm_base;
				margin-left: 10*@vm_base;
				transform: rotateZ(90deg);
			}
		}
		.co_2_org{
			color: #F77F28;
		}
	}
	.co_3{
		width: 100%;
		padding-top: 20*@vm_base;
		font-size: 30*@vm_base;
		color: #333333;
		padding-bottom: 10*@vm_base;
		div{
			width: fit-content;
			white-space: nowrap;
			border: 1*@vm_base solid #F77F28;
			font-size: 26*@vm_base;
			color: #F77F28;
			padding: 10*@vm_base 20*@vm_base;
			border-radius: 24*@vm_base;
			img{
				width: 26*@vm_base;
				margin-right: 6*@vm_base;
			}
		}
	}
	.co_4{
		width: 100%;
		.co_4_1{
			width: 68*@vm_base;
			height: 34*@vm_base;
			background: rgba(247,127,40,0.1);
			border-radius: 16*@vm_base 4*@vm_base;
			font-size: 24*@vm_base;
			color: #F77F28;
		}
		.co_4_2{
			width: calc(100% - 88*@vm_base);
			height: 56*@vm_base;
			font-size: 28*@vm_base;
			color: #333333;
			.co_4_2_input{
				width: calc(100% - 56*@vm_base);
				height: 56*@vm_base;
				border: none;
			}
			.co_4_2_del{
				width: 56*@vm_base;
				height: 56*@vm_base;
				img{
					width: 30*@vm_base;
				}
			}
		}
	}
	.co_5{
		width: 100%;
		margin-top: 20*@vm_base;
		border-top: 1*@vm_base solid #F0F0F0;
		padding-top: 28*@vm_base;
		.co_5_1{
			font-size: 30*@vm_base;
			color: #333333;
			padding-bottom: 20*@vm_base;
		}
		.co_5_2{
			width: 100%;
			height: 50*@vm_base;
			font-size: 28*@vm_base;
			color: #333333;
		}
		.co_5_3{
			width: 100%;
			padding: 20*@vm_base 0 100*@vm_base 0;
			font-size: 30*@vm_base;
			color: #333333;
			div{
				color: #F77F28;
			}
		}
	}
	.co_6{
		width: 100%;
		padding: 25*@vm_base 30*@vm_base;
		border-radius: 16*@vm_base 16*@vm_base 0 0;
		box-shadow: -4px -4px 6px rgba(243, 207, 166, 0.5);
		.co_6_left{
			.co_6_left_1{
				font-size: 24*@vm_base;
				color: #333333;
				line-height: 1.3;
			}
			.co_6_left_2{
				font-size: 26*@vm_base;
				color: #F77F28;
				line-height: 1.3;
			}
			.co_6_left_3{
				font-size: 54*@vm_base;
				color: #F77F28;
			}
		}
		.co_6_right{
			width: 250*@vm_base;
			height: 80*@vm_base;
			background: linear-gradient( 319deg, #FB8027 0%, #FFA663 100%);
			border-radius: 40*@vm_base;
			font-size: 32*@vm_base;
			color: #FFFFFF;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/create_order.vue